

import React from 'react';
import Grid from '@mui/material/Grid2';
import {
    Box,
} from '@mui/material';
import './NotFound.css'



const NotFound = () => {

    return (
        <Box component="section" className="headerBox" style={{height:'60vh'}}>
            <Grid container className="container">
                <Grid item size={12} >

                    <h2>Not Found!</h2>
                    
                    <h3 style={{color: 'rgb(56 56 56)'}}>The page you're looking for is not found!</h3>
                    
                </Grid>
            </Grid>
        </Box>
    )
}

export default NotFound;